export default __webpack_public_path__ + "static/solutionIot-1e11be59f07ef8092471dc9da59103d3.png";